module.exports = __webpack_public_path__ + "static/media/jo.8e5c45e7.svg";